import React, { MouseEvent, RefObject, forwardRef } from 'react';
import { IWorkCalendarDay, getWeekDayIndex, isNonWorkingDay, setClass } from '@utils';
import { observer } from 'mobx-react-lite';

interface ColProps {
  day?: Date;
  hours: number[];
  isCanAddMeeting?: (day: Date, hour: number) => boolean;
  onMouseDownDay?: (e: MouseEvent<HTMLDivElement>, day: Date, hour: number) => void;
  onMouseMoveCol?: (e: MouseEvent<HTMLDivElement>, day: Date) => void;
  onMouseUpDay?: (e: MouseEvent<HTMLDivElement>, day: Date, hour: number) => void;
  isDayCalendar?: boolean;
  workCalendarDay?: IWorkCalendarDay
}

/**
 * @day  день передается только для столбцов интервала(дня/ недели). Не передается для столбца с часами
 * @hours  массив часов с startHour до 23
 */
export const Col = observer(forwardRef<HTMLDivElement, ColProps>((
  { day, hours, isCanAddMeeting, onMouseMoveCol, onMouseDownDay, onMouseUpDay, isDayCalendar, workCalendarDay}, ref: RefObject<HTMLDivElement>
) => {
  const onMouseMove = (e: MouseEvent<HTMLDivElement>) => onMouseMoveCol && onMouseMoveCol(e, day);
  const isWeekendHoliday = isNonWorkingDay(getWeekDayIndex(day), workCalendarDay) && !isDayCalendar;
  
  return (
    <div
      className={setClass('col', !day && ' time')}
      ref={ref}
      onMouseMove={onMouseMove}
    >
      {hours.map((hour) => {
        const onMouseDown = (e: MouseEvent<HTMLDivElement>) => onMouseDownDay && onMouseDownDay(e, day, hour);
        const onMouseUp = (e: MouseEvent<HTMLDivElement>) => onMouseUpDay && onMouseUpDay(e, day, hour);
        return (
          <div
            key={hour}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            className={setClass('day', !day && ' time', isCanAddMeeting && isCanAddMeeting(day, hour) && 'can-add-meeting', isWeekendHoliday && 'weekend-holiday')}
          >
            <div className="hours">
              {!day && (hour < 10 ? `0${hour}:00` : `${hour}:00`)}
            </div>
          </div>
        );
      })}
    </div>
  );
}));
